import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';

import { QBooksExpandedRequest } from '../../../../../../modules/common/selectors/types';
import { QBooksRequest } from '../../../../../../modules/data/domain';
import { requestSelector } from '../../../../selectors/pageSelectors';

export const useRequest = <
    Request extends QBooksRequest = domain.QBooksBillRequest | domain.QBooksPoRequest | domain.QBooksExpenseRequest,
>() => {
    return <Request>useSelector(requestSelector);
};

export const useRequestExpanded = <
    Request extends QBooksExpandedRequest =
        | selectors.types.QBooksBillExpandedRequest
        | selectors.types.QBooksPoExpandedRequest
        | selectors.types.QBooksExpenseExpandedRequest,
>() => {
    const request = useRequest();

    return useSelector((state) => selectors.request.expandRequest(state, request) as Request);
};
